var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowDarkIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.16 390.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#7c5d25;}.cls-3{fill:#c9862c;}.cls-4{fill:#281f12;}.cls-5{fill:#1d1710;}.cls-6{fill:#634e1f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.39,229.85C517.13,227.5,318.89,21.4,311,13.07c-8.55-8.95-19.88-4.84-20.09-4.76.1,0,.66-.27-9.53,2.65-10.79,3.09-14.29-.8-14.29-.8s-4-5.24-17.63-1.28C233.58,13.45,7.86,70.81,7.86,70.81S.77,72.63.69,79.9,0,124.65,0,124.65,195.25,376,202.91,386c6.27,8.2,22,2.49,22,2.49s284.08-103,290.7-105.41c5.81-2.49,5.39-7.66,5.39-7.66l.13-37.91S521.36,232,519.39,229.85Zm-97.85-57.59-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35L315,59.24a12.76,12.76,0,0,1,11.55,3.2L423.38,165C426,167.78,425.2,171.06,421.54,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M482.88,185.58C481,183.62,315.79,11.86,309.17,4.93c-7.11-7.46-16.56-4-16.73-4,.08,0,.55-.23-7.94,2.2-9,2.58-11.92-.66-11.92-.66s-3.29-4.36-14.69-1.07C244.7,5.24,56.6,53,56.6,53s-5.91,1.52-6,7.57-.58,37.3-.58,37.3S212.76,307.39,219.14,315.69c5.23,6.83,18.36,2.08,18.36,2.08S474.24,232,479.75,229.92c4.84-2.07,4.5-6.38,4.5-6.38l.1-31.59S484.52,187.34,482.88,185.58Zm-61.34-13.32-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35L315,59.24a12.75,12.75,0,0,1,11.54,3.2L423.38,165C426,167.78,425.2,171.06,421.54,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480.26,182.73S315.79,11.75,309.17,4.81c-7.11-7.46-16.56-4-16.73-4,.08,0,.55-.22-7.94,2.21-9,2.57-11.92-.66-11.92-.66S269.29-2,257.89,1.31C244.7,5.12,56.6,52.93,56.6,52.93s-8.71,3-3.6,9.42L101.6,126S209.11,261.24,217.15,271.29s23.12,3.88,23.12,3.88,227.06-77.39,237.78-81S480.26,182.73,480.26,182.73Zm-58.72-10.47-184,60.7a10.84,10.84,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35L315,59.24a12.76,12.76,0,0,1,11.55,3.2L423.38,165C426,167.78,425.2,171.06,421.54,172.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "241.96 281.15 241.96 308.67 474.77 224.48 474.77 201.17 241.96 281.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "474.77 201.17 458.43 206.84 474.77 224.48 474.77 201.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.3,128.13l-7.76,1.57c17.27,21.72,105.36,132.53,112.61,141.59A15.61,15.61,0,0,0,228.9,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480.26,182.73S409.73,109.41,359.19,56.84l-4.08,1.74L482.52,191.4C485.55,187.57,480.26,182.73,480.26,182.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.84,58.53c-8.47,2.19-26.71,8.67-16.64,21.56s24.94,13.26,42.42,8.43,132.73-36.46,143.9-39.6,25.7-9.77,12.89-21.8S269,18.41,254.65,22.2,125.32,56.33,116.84,58.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317.25,13.22l-2-2L290.2,17.92a31.13,31.13,0,0,1,3.67,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.63,70.72,64.94,78.07l1.92,2.51,25.8-6.91A9.15,9.15,0,0,1,92.63,70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M321.46,17.6l-1.95-2-22.27,6a29,29,0,0,1,2.45,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.45,82.62l1.93,2.5,24.23-6.47A17.48,17.48,0,0,1,93.32,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.79,27.77l21.75-5.92-1.94-2L302,25.69c.32.33.64.67.94,1S303.52,27.42,303.79,27.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.43,81.29,72.36,87.8l1.94,2.49L98.44,83.7c-.47-.53-1-1.08-1.42-1.65C96.81,81.79,96.62,81.54,96.43,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.08,92.56l2,2.49,25.17-6.89c-.88-.69-1.74-1.44-2.6-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.63,26.1l-1.94-2-22.24,6.05a15.89,15.89,0,0,1,1.18,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.28,96.8l2,2.48,27.69-7.54a30.71,30.71,0,0,1-3.51-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.43,37.37l26.16-7.16-1.93-2-24.31,6.61A8.81,8.81,0,0,1,307.43,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M429.49,165.28,329.88,59.9A16.44,16.44,0,0,0,315,55.79l-183.55,51.5c-4.76,1.34-6.12,5.59-3,9.44L222.8,233.88A14,14,0,0,0,237,238.05l190.15-63.39C431.83,173.1,432.89,168.87,429.49,165.28Zm-7.95,7-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35L315,59.24a12.76,12.76,0,0,1,11.55,3.2L423.38,165C426,167.78,425.2,171.06,421.54,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.31,217.59c-3.12-1.08-3.11-2.79,0-3.82l22.32-7.3c3.13-1,5.27.8,4.74,4.06l-1.55,9.58a4.9,4.9,0,0,1-6.63,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowDarkIsometric);
export default __webpack_public_path__ + "static/media/yellow-dark-isometric.13cb15d22a19192666ccd52c21bac5d8.svg";
export { ForwardRef as ReactComponent };